import { Transition } from '@unseenco/taxi';

/**
 * Use Taxi Transition
 *
 * @param object app The app.
 */
export default function menuTransition(app) {
  /**
   * Taxi transition
   */
  return class navTransition extends Transition {
    /**
     * In
     *
     * @param object param0 In params.
     */
    onEnter({ done }) {
      app.$children.Sidebar[0].closeMenu();
      done();
      app.$update();
    }

    /**
     * Out
     */
    onLeave({ done }) {
      done();
    }
  };
}
